<template>
  <dashboard-page :image-header-props="imageHeaderProps">
    <template v-slot:header>
      <div class="flex-column full-height full-width align-center">
        <div class="flex-row full-height full-width" :style="{alignItems: 'flex-end'}">
          <div class="ri-small-display margin-bottom-xxs" :style="{textAlign: 'right'}">
            סידרנו לך הנחה על קניות בסופר
          </div>

          <img :style="{width: '160px', height: '160px'}" :src="require('@/assets/super-discount/groceries.png')"/>
        </div>
        <div :style="{height: '26px'}"></div>
      </div>
    </template>
    <template v-slot:dashboard>
      <div class="padding-horizontal-ml padding-vertical-l flex-row">
        <img :src="require('@/assets/super-discount/rami/card-logo.svg')" />
        <div class="margin-right-m flex-column space-between">
          <div class="ri-large-bold"><span class="ri-large-bold-body">רשת רמי לוי</span> (התו המלא)</div>
          <div class="ri-label">תו קנייה בהנחה של 5%</div>
          <card-action-button text="לקנות תווים בהנחה" @click="goToRami"
                              :background-color="buttonProps.backgroundColor"
                              :text-color="buttonProps.textColor"
                              :border-color="buttonProps.borderColor"/>
        </div>
      </div>
    </template>
    <div class="full-width padding-horizontal-ml padding-top-m">
      <card>
        <div class="padding-vertical-l flex-row">
          <img :src="require('@/assets/super-discount/carrefour/card-logo.svg')" />
          <div class="margin-right-m flex-column space-between">
            <div class="ri-large-bold"><span class="ri-large-bold-body">רשת קרפור</span> (תו פלוס)</div>
            <div class="ri-label">תו קנייה בהנחה של 7%</div>
            <card-action-button text="לקנות תווים בהנחה" @click="goToCarrefour"
                                :background-color="buttonProps.backgroundColor"
                                :text-color="buttonProps.textColor"
                                :border-color="buttonProps.borderColor"/>
          </div>
        </div>
      </card>
    </div>
  </dashboard-page>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

import * as LayoutConsts from '@riseupil/base-ui/src/utils/layout-consts';
import { mapActions } from 'vuex';
import router from '@/router';
import CardActionButton from '@/base-components/card-parts/CardActionButton.vue';
import Segment from '@/Segment';

export default {
  name: 'SuperDiscountPage',
  components: {
    CardActionButton,
    DashboardPage: BaseUI.Pages.DashboardPage,
    Card: BaseUI.Card,
  },
  data() {
    return {
      buttonProps: {
        backgroundColor: BaseUI.Colors.riseupBlue,
        textColor: BaseUI.Colors.riseupWhite,
        borderColor: BaseUI.Colors.riseupBlue,
      },
    };
  },
  computed: {
    imageHeaderProps() {
      return {
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
        bottomSeparator: false,
      };
    },
  },
  created() {
    Segment.trackUserGot('AllSuperDiscount_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: LayoutConsts.COLOR_VARIANT.GREEN,
      logoColor: BaseUI.Colors.riseupWhite,
      textColor: BaseUI.Colors.riseupWhite,
    });
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),

    async goToRami() {
      Segment.trackUserInteraction('AllSuperDiscount_RamiLevi_Clicked');
      await router.push({ name: 'RamiLeviDiscountPage' });
    },

    async goToCarrefour() {
      Segment.trackUserInteraction('AllSuperDiscount_Carrefour_Clicked');
      await router.push({ name: 'CarrefourDiscountPage' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";

</style>
